import Link from 'next/link'

import styled from 'styled-components'
import themeGet from '@styled-system/theme-get'

export const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  gap: ${themeGet('space.4')}px;
  color: ${themeGet('colors.text.inverse')};
  text-decoration: none;
`
